export function getView(id) {
  return id ? 'SignIn' : 'NotFound'
}
